/**
 * Dev-only bypass of the App.vue onboard-route redirect (spec F12), so
 * /onboard-pricing?preview=1 can be QA'd on stores past onboarding.
 * Never active in production.
 */
export function shouldBypassOnboardGuard(
  query: Record<string, any>,
  environment: string | undefined,
): boolean {
  return environment !== 'production' && query.preview === '1';
}
